<template>
  <sui-modal v-model="visible" :size="size" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Access settings
    </sui-modal-header>
    <sui-modal-content scrolling>
      <sui-form warning :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <Access :entity="entity" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors || !hasChanges || !access.accManagement" data-goal="ACCESS_UPDATE_TRY" @click="submit()">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import Access from '@/components/forms/Access'
  import ModalForm from '@/mixins/ModalForm'
  import utils from '@/utils'

  export default {
    name: 'ModalAccess',
    mixins: [
      ModalForm,
    ],
    components: {
      Access,
    },
    props: {
      name: {
        type: String,
        required: false,
        default: 'access'
      }
    },
    computed: {
      ...mapGetters(['access', 'account']),
      mode() {
        return 'updatingAccess'
      },
      size() {
        return (this.name === 'globalAccess') ? 'small' : 'standard'
      },
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal(`ACCESS_UPDATE_SUCCESS`)
      },
      onFail() {
        utils.reachGoal(`ACCESS_UPDATE_FAIL`)
      },
      submit() {
        const method = this.entity.actions ? 'update' : 'updateRules'
        const data = this.entity.actions ? {actions: this.entity.actions} : this.entity.rules.local
        this.apiErrors = null
        this.loading = true
        return this.entity[method](data).then(result => {
          this.success = true
          setTimeout(() => {
            this.onSuccess(result)
          }, 1000)
        }).catch(error => {
          this.apiErrors = error
          this.onFail(error)
        }).finally(() => {
          this.loading = false
        })
      },
    },
    created() {
      this.$modals[this.name] = this
    },
  }
</script>

<style scoped>
  .scrolling { overflow-x: hidden!important; }
</style>
